<div
  bind:this={element}
  use:useActions={use}
  use:forwardEvents
  class={classMap({
    [className]: true,
    'mdc-layout-grid__inner': true,
  })}
>
  <slot />
</div>

<script>import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, classMap, useActions, } from '@smui/common/internal';
const forwardEvents = forwardEventsBuilder(get_current_component());
// Remember to update $$Props if you add/remove/rename props.
export let use = [];
let className = '';
export { className as class };
let element;
export function getElement() {
    return element;
}
</script>
